import Application from './application';

export default Application;
